(() => {
  const formatMoney = (value) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-exyr-header]');
    const stickyBuy = document.querySelector('[data-rest-sticky-buy]');
    const buySection = document.querySelector('#buy');

    const syncScrollState = () => {
      header?.classList.toggle('is-scrolled', window.scrollY > 24);

      if (stickyBuy && buySection) {
        const buyTop = buySection.getBoundingClientRect().top;
        stickyBuy.classList.toggle('is-visible', window.scrollY > 540 && buyTop > window.innerHeight * 0.35);
      }
    };

    syncScrollState();
    window.addEventListener('scroll', syncScrollState, { passive: true });

    const revealItems = document.querySelectorAll('.rest-reveal');
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        }),
        { threshold: 0.12 }
      );

      revealItems.forEach((element, index) => {
        element.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
        revealObserver.observe(element);
      });
    } else {
      revealItems.forEach((element) => element.classList.add('is-visible'));
    }

    const setupTabs = (root, buttonSelector, panelSelector, buttonKey, panelKey) => {
      const buttons = [...root.querySelectorAll(buttonSelector)];
      const panels = [...root.querySelectorAll(panelSelector)];
      if (!buttons.length || !panels.length) return;

      const activate = (selectedButton, moveFocus = false) => {
        const selectedValue = selectedButton.dataset[buttonKey];

        buttons.forEach((button) => {
          const active = button === selectedButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset[panelKey] !== selectedValue;
        });

        if (moveFocus) selectedButton.focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = buttons.length - 1;
          else return;

          event.preventDefault();
          activate(buttons[nextIndex], true);
        });
      });
    };

    document.querySelectorAll('[data-rest-section]').forEach((section) => {
      const packs = [...section.querySelectorAll('[data-rest-pack]')];
      const quantityInput = section.querySelector('[data-rest-quantity]');
      const buttonPrice = section.querySelector('[data-rest-button-price]');

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          const quantity = Number(pack.dataset.restPack || 1);
          const displayPrice = Number(pack.dataset.restPrice || 0);

          packs.forEach((item) => item.classList.toggle('is-active', item === pack));
          if (quantityInput) quantityInput.value = String(quantity);
          if (buttonPrice && Number.isFinite(displayPrice)) buttonPrice.textContent = formatMoney(displayPrice);
        });
      });

      const sideButtons = [...section.querySelectorAll('[data-rest-side]')];
      const sidePanels = [...section.querySelectorAll('[data-rest-side-copy]')];

      sideButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selectedSide = button.dataset.restSide;

          sideButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', String(active));
          });

          sidePanels.forEach((panel) => {
            panel.hidden = panel.dataset.restSideCopy !== selectedSide;
          });
        });
      });

      setupTabs(section, '[data-rest-pain-tab]', '[data-rest-pain-panel]', 'restPainTab', 'restPainPanel');
      setupTabs(section, '[data-rest-step-tab]', '[data-rest-step-panel]', 'restStepTab', 'restStepPanel');
    });
  });
})();
